import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';

export type ForgeUIRuntimeType = 'webworker' | 'iframe' | 'iframev2';

/**
 * Contributes the rendering runtime to `forgeUIAttributes` for every Forge UI
 * analytics event fired by descendant components.
 */
export const ForgeUIRuntimeAnalyticsContext = ({
	runtime,
	children,
}: {
	children: React.ReactNode;
	runtime: ForgeUIRuntimeType;
}): React.JSX.Element => (
	<AnalyticsContext data={{ forgeUIAttributes: { runtime } }}>{children}</AnalyticsContext>
);
